export const formatStudentOption =
  (showFacultyNumber = true) =>
  record => {
    if (!record || !record?.studentInfo) return "";

    const { firstName, secondName, lastName, facultyNumber } = record?.studentInfo;

    const fullName = secondName ? `${firstName} ${secondName} ${lastName}` : `${firstName} ${lastName}`;
    if (showFacultyNumber && facultyNumber) {
      return `${facultyNumber} - ${fullName}`;
    }
    return fullName;
  };
